import React, { Component } from 'react';
// import { get } from 'lodash';
import PT from 'prop-types';
import { connect } from 'react-redux';
import { goToView } from '../../routes.global';
import {
  selectTeamRanksMatchupsState,
  TEAM_PRM_VIEW,
} from './module/teamPRM';
import FiltersHeader from '../../../app/components/FiltersHeader';
import TableControls from '../../components/TableControls';
import FilterRangeSlider from '../../components/FilterComponents/FilterRangeSlider';
import FilterToggle from '../../components/FilterComponents/FilterToggle';
import { positionToTitle } from '../../../lib/lookups';
import PlainTable from '../../components/DataTable/PlainTable';
import classes from './teamPRM.css';
import MatchupCell from '../../components/DataTable/StatCells/MatchupCell';
import { DESKTOP } from '../../../store/actions/browser.types';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';


/* eslint camelcase: 0 */
/* eslint no-return-assign: 0 */

const pageTitle = 'Team Position Rank Matchups';

const TeamMatchupCell = ({ logo, team, text }) => (
  <span className={classes.teamMatchupCell}>
    {logo && <img src={logo} className={classes.teamlogo} alt={team} />}
    {(text.indexOf('offense') > -1 || text.indexOf('Adv.') > -1) ? <b>{`${team} `}</b> : <span>{`${team} `}</span>} {text}
  </span>
);

TeamMatchupCell.propTypes = {
  logo: PT.string,
  team: PT.string.isRequired,
  text: PT.oneOfType([PT.string, PT.number]).isRequired,
};

TeamMatchupCell.defaultProps = {
  logo: null,
};

export class TeamPositionRanksMatchups extends Component {

  static propTypes = {
    showStart: PT.number.isRequired,
    showEnd: PT.number.isRequired,
    matchups: PT.arrayOf(PT.object).isRequired,
    hasLoaded: PT.bool.isRequired,
    goToView: PT.func.isRequired,
    selectedFormula: PT.number.isRequired,
    selectedYear: PT.number.isRequired,
    mediaType: PT.string.isRequired,
    toolsLoaded: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  };

  state = {
    showRanks: true,
  }

  prepHeaders = () => {
    const colKeys = [];
    const colLabels = [];
    const colWidths = [];
    const positions = ['QB', 'RB', 'WR', 'TE', 'PK', 'DF'];
    colKeys.push('matchups');
    colLabels.push('Matchups');
    colWidths.push('21rem');
    positions.forEach(position => {
      colKeys.push(position);
      colLabels.push(positionToTitle(position, { capitalize: true }));
      colWidths.push('6.5rem');
    });
    return { colKeys, colLabels, colWidths };
  };

  prepStats = () => {
    const { matchups, hasLoaded } = this.props;
    const allStatRows = [];
    let stripeGroup = false;
    if (hasLoaded) {
      matchups.forEach(matchup => {

        // Offense Row
        const offensiveMatchupRow = {};
        ({ team_logo, team_abbr, stats } = matchup.offensive_team);
        offensiveMatchupRow.matchups = <TeamMatchupCell logo={team_logo} team={team_abbr} text={'offense ranks'} />;
        offensiveMatchupRow.isRank = true;
        offensiveMatchupRow.stripeGroup = stripeGroup;
        Object.keys(stats).forEach(statKey => offensiveMatchupRow[statKey] = stats[statKey]);

        // Defensive Row
        const defensiveMatchupRow = {};
        let { team_logo, team_abbr, stats } = matchup.defensive_team;
        defensiveMatchupRow.matchups = <TeamMatchupCell logo={team_logo} team={team_abbr} text={'defense ranks'} />;
        defensiveMatchupRow.isRank = true;
        defensiveMatchupRow.stripeGroup = stripeGroup;
        Object.keys(stats).forEach(statKey => defensiveMatchupRow[statKey] = stats[statKey]);

        const matchupRow = {};
        ({ team_abbr, stats } = matchup.matchup);
        matchupRow.matchups = <TeamMatchupCell team={team_abbr} text={'Adv. (+) / Disadv. (-)'} />;
        matchupRow.stripeGroup = stripeGroup;
        Object.keys(stats).forEach(statKey => {
          let rating = '';
          if (stats[statKey] >= 10) rating = 'good';
          else if (stats[statKey] <= -10) rating = 'bad';
          else rating = 'neutral';
          if (stats[statKey] > 0 && (stats[statKey]+"").indexOf("+") == -1) stats[statKey]="+"+stats[statKey];
          matchupRow[statKey] = <MatchupCell rating={rating}>{stats[statKey]}</MatchupCell>;
        });

        allStatRows.push(offensiveMatchupRow, defensiveMatchupRow, matchupRow);
        stripeGroup = !stripeGroup;
      });
    }
    return allStatRows;
  };

  handleShowWeeksChange = range => {
    const { min, max } = range;
    const { showStart, showEnd } = this.props;
    if (min !== showStart || max !== showEnd) {
      this.props.goToView(TEAM_PRM_VIEW, {
        query: { showStart: min, showEnd: max },
      });
    }
  };

  handleChangeYear = (event, { value }) => {
    if (this.props.selectedYear !== value) {
      document.location = '/stats/team-position-rank-matchups?year=' + value;
      // this.props.goToView(TEAM_PRM_VIEW, { query: { year: value } });
    }
  };

  handleChangeFormula = (event, { value }) => {
    if (this.props.selectedFormula !== value) {
      this.props.goToView(TEAM_PRM_VIEW, { query: { formulaId: value } });
    }
  };

  toggleShowRanks = () => this.setState(prevState => ({ showRanks: !prevState.showRanks }));

  render() {
    const { hasLoaded, selectedFormula, selectedYear, mediaType, showStart, showEnd, toolDescriptions, toolsLoaded } = this.props;
    const { showRanks } = this.state;
    const isDesktop = mediaType === DESKTOP;
    const showSliderOptions = {
      value: { min: showStart, max: showEnd },
      minValue: 1,
      maxValue: selectedYear >= 2021 ? 18 : 17,
      formatLabel: value => `Wk${value}`,
      onChangeComplete: this.handleShowWeeksChange,
      sliderLabel: 'Show Range:',
    };

    const { colKeys, colLabels, colWidths } = this.prepHeaders();
    const allStatRows = showRanks ? this.prepStats() : this.prepStats().filter(row => !row.isRank);
    // Matchup label should depend on week, Week ${showEnd + 1}
    colLabels[0] = `Matchups`;
    const colGroups = [{ name: '', columns: colKeys, colLabels }];

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle}
          description={toolsLoaded && toolDescriptions.tool_descriptions.team_position_rank_matchups.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.team_position_rank_matchups.text}
            />)}
          seasonType="seasons"
          statType="stats"
          selectedYear={selectedYear}
          selectedProfile={selectedFormula}
          onChangeProfile={this.handleChangeFormula}
          onChangeYear={this.handleChangeYear}
        >
          <FilterRangeSlider {...showSliderOptions} />
          <FilterToggle
            label={'Show Team Ranks:'}
            checked={showRanks}
            valueOff={'NO'}
            valueOn={'YES'}
            onChange={this.toggleShowRanks}
          />
        </FiltersHeader>
        <TableControls matchup density={false} colGroups={[]} />
        {hasLoaded && (
          <PlainTable
            data={allStatRows}
            colGroups={colGroups}
            teamColor={''}
            equalWidthCols={isDesktop}
            colWidths={isDesktop ? colWidths : null}
            className={classes.teamRankingsTable}
            disableSort
            initialSortColumn="team_abbr"
            tableTitleFixed={false}
            tableStatsFixed={true}
          />
        )}
      </div>
    );
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }
}

const mapStateToProps = state => {
  const {
    matchups,
    hasLoaded,
    formulaId: selectedFormula,
    year: selectedYear,
    showStart,
    showEnd,
  } = selectTeamRanksMatchupsState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  const { mediaType } = state.browser;

  return {
    matchups,
    hasLoaded,
    selectedFormula,
    selectedYear,
    showStart,
    showEnd,
    mediaType,
    toolDescriptions,
    toolsLoaded,
  };
};

const mapDispatchToProps = {
  goToView,
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamPositionRanksMatchups);



// WEBPACK FOOTER //
// ./src/app/views/TeamPositionRanksMatchups/TeamPRM.js